import { io } from "socket.io-client"

import { store } from "@redux"
import delay from "./delay"
import listenToIncomingEvents from "./listenToIncomingEvents"
import { getApiOrigin } from "services/api"

let socket = null

const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL

const normalizeSocketUrl = (url) => {
  if (!url) return url

  return url.replace(/\/socket\/?$/, "")
}

const handleSocketConnectionError = async (err) => {
  if (err?.message !== "unauthorized") return

  // wait until other api requests get new access token
  await delay(1000)

  createSocketConnectionToServer()
}

const createSocketConnectionToServer = () => {
  if (!!socket) {
    socket.removeListener("basicEmit", handleSocketConnectionError)

    socket.removeListener("connect_error", handleSocketConnectionError)
  }

  const { tokens, systemSettings } = store.getState()

  const { domain, subdomain } = systemSettings

  const url =
    normalizeSocketUrl(SOCKET_URL || getApiOrigin(domain))

  const path =
    process.env.NODE_ENV === "production"
      ? "/socket/s/"
      : "/s/"

  socket =
    io(
      url,
      {
        withCredentials: true,
        path,
        transports: ["websocket"],
        auth: {
          token: `Bearer ${tokens.accessToken}`,
          clientName: subdomain
        }
      }
    )

  socket.on("basicEmit", listenToIncomingEvents)

  socket.on("connect_error", handleSocketConnectionError)

  return socket
}

const getSocket = () => socket

export default {
  getSocket,
  createSocketConnectionToServer
}
